<template>
  <div class="gcu-multiselect">
    <b-form-group
      :label="label"
      :label-cols="spacing"
      :horizontal="true">
      <multiselect
        :value="value"
        v-model="selected"
        @input="updateInput()"
        :options="gcuNames"
        track-by="name"
        label="name"
        :multiple="multiple"
        selectLabel=""
        deselectLabel="Remove"
        placeholder="Select GCU"
        :disabled="selectedSite === null"
        :class="{invalid: invalid}">
      </multiselect>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';

export default {
  name: 'GcuDropdown',
  components: {
    Multiselect
  },
  props: {
    value: [Object, Array],
    label: {
      type: String,
      default: 'GCU'
    },
    spacing: {
      type: Number,
      default: 3
    },
    siteRequired: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cacheKey: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: null,
      initializedGcuNames: false
    };
  },
  computed: {
    ...mapGetters('savanna/sites', {
      selectedSite: 'getSelectedSite'
    }),
    gcuNames() {
      if (this.selectedSite) return this.$store.getters['savanna/gcus/getGCUNames'](this.selectedSite.id);
      else return [];
    }
  },
  methods: {
    updateInput() {
      this.$emit('input', this.selected);

      if (this.cacheKey) {
        if (this.selected) {
          this.$store.dispatch('localstorage/saveToLocalStorage', { key: 'gcu_' + this.cacheKey, value: this.selected });
        } else {
          this.$store.dispatch('localstorage/removeFromLocalStorage', { key: 'gcu_' + this.cacheKey });
        }
      }
    }
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    gcuNames: {
      immediate: true,
      handler(names) {
        this.selected = null;
        this.$emit('input', this.selected);

        if (names.length === 0) return;

        if (!this.initializedGcuNames && this.cacheKey) {
          this.initializedGcuNames = true;
          this.$store.dispatch('localstorage/getFromLocalStorage', { key: 'gcu_' + this.cacheKey })
            .then((data) => {
              if (data) {
                if (!this.multiple) {
                  const found = names.find((val) => {
                    return val.id === data.id && val.name === data.name;
                  });

                  if (found) {
                    this.selected = data;
                    this.$emit('input', this.selected);
                  } else {
                    this.$store.dispatch('localstorage/removeFromLocalStorage', { key: 'gcu_' + this.cacheKey });
                  }
                }

                else {
                  let foundAll = true;
                  data.forEach((element, index) => {
                    const found = names.find((val) => {
                      return val.id === element.id && val.name === element.name;
                    });

                    if (!found) {
                      foundAll = false;
                    }
                  });

                  if (foundAll) {
                    this.selected = data;
                    this.$emit('input', this.selected);
                  } else {
                    this.$store.dispatch('localstorage/removeFromLocalStorage', { key: 'gcu_' + this.cacheKey });
                  }
                }
              }
            });
        }
      }
    }
  }
};
</script>

<style scoped>
  .form-group {
    margin-bottom: 0.5rem;
  }
</style>
<style>
  .gcu-multiselect .multiselect .multiselect__option--highlight {
    background: #FF9E1B
  }

  .gcu-multiselect .multiselect .multiselect__option--selected.multiselect__option--highlight {
    background: #FF6A6A
  }

  .gcu-multiselect .multiselect.invalid .multiselect__tags {
    border-color: #F86C6B
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
